<template>
  <section class="tickets-widget grid">
    <h1 v-if="isFirst" class="heading wildwaffle" v-html="nbsp(widget.title)" />
    <h2 v-else class="heading wildwaffle" v-html="nbsp(widget.title)" />
    <CollapseGroup class="ticket-types-list" tag="ul">
      <Collapse
        v-for="ticketType in widget.ticket_types"
        :id="`${ticketType.id}`"
        :key="ticketType.id"
        :initial-active="ticketType.id === initiallyActiveId"
        tag="li"
      >
        <TicketsCollapseTitle :ticket-type="ticketType" />
        <TicketsCollapseContent
          :ticket-type="ticketType"
          :current-edition="widget.current_edition"
        />
      </Collapse>
    </CollapseGroup>
  </section>
</template>

<script setup lang="ts">
import { PublicTicketsWidget } from '@/service/__generated-api'
import { Widget } from '@/types/utils'

const props = defineProps<Widget<PublicTicketsWidget>>()

const initiallyActiveId = computed(
  () => props.widget.ticket_types.find(({ status }) => status === 'on_sale')?.id
)
</script>

<style scoped lang="scss">
.heading {
  @include media-column(
    (
      xs: 4,
      md: 8,
      lg: 12
    )
  );

  @include font-size(
    (
      xs: 45px 0.9555555556,
      md: 72px 0.9444444444,
      lg: 92px 0.9565217391
    )
  );
  padding-block-end: rem(32px);
  margin-block-end: rem(16px);
  text-transform: uppercase;
  border-bottom: $base-border;

  @include media-up(xl) {
    margin-block-end: rem(24px);
  }
}

.ticket-types-list {
  @include media-column(
    (
      xs: 4,
      md: 8,
      lg: 12
    )
  );

  display: flex;
  flex-direction: column;
  gap: rem(16px);

  @include media-up(xl) {
    gap: rem(20px);
  }
}
</style>
